export default __webpack_public_path__ + "static/media/Group 8158.e4ec193b.png";